/**
 * Axios Interceptor Setup
 * 
 * Automatically add request signature to all API calls.
 * Import and call setupAxiosInterceptors() di index.js atau App.js
 */

import axios from 'axios';
import { addSignatureHeaders, isSignatureRequired } from './requestSignature';

/**
 * Setup axios interceptors untuk auto-sign requests
 */
export const setupAxiosInterceptors = () => {
  // Request interceptor - add signature
  axios.interceptors.request.use(
    (config) => {
      // Check if signature is required for this request
      if (isSignatureRequired(config.url)) {
        config = addSignatureHeaders(config);
        console.log('✅ Request signed:', config.method.toUpperCase(), config.url);
      } else {
        console.log('⚪ Request unsigned (whitelisted):', config.url);
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor - handle signature errors
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        const { status, data } = error.response;
        
        // Handle signature validation errors
        if (status === 403 && data.error === 'SIGNATURE_VALIDATION_FAILED') {
          console.error('❌ Signature validation failed!');
          console.error('Error:', data.message);
          
          // Optional: redirect to error page or show notification
          // window.location.href = '/error/signature-failed';
        }
        
        // Handle rate limit errors
        if (status === 429 && data.error === 'TOO_MANY_REQUESTS') {
          console.error('❌ Rate limit exceeded!');
          console.error('Error:', data.message);
          console.error('Retry after:', data.retryAfter, 'seconds');
          
          // Optional: show user-friendly message
          // alert('Terlalu banyak request. Silakan coba lagi setelah 1 menit.');
        }

        // Handle NPWP authorization errors
        if (status === 403 && data.error === 'FORBIDDEN') {
          console.error('❌ NPWP authorization failed!');
          console.error('Error:', data.message);
          
          // Optional: redirect to unauthorized page
          // window.location.href = '/error/unauthorized';
        }
      }
      
      return Promise.reject(error);
    }
  );

  console.log('🔒 Axios interceptors setup complete - Request signing enabled');
};

/**
 * Example usage:
 * 
 * // In your index.js or App.js:
 * import { setupAxiosInterceptors } from './app/helpers/axiosInterceptor';
 * 
 * setupAxiosInterceptors();
 * 
 * // Now all axios requests will be automatically signed!
 * axios.get('/api/soa/123456789012345')
 *   .then(response => console.log(response.data))
 *   .catch(error => console.error(error));
 */
